// extracted by mini-css-extract-plugin
var _1 = "PostHistory-module__animatedBackground--LqRwB";
var _2 = "PostHistory-module__restrictionContainer--g4DMX";
var _3 = "PostHistory-module__restrictionNote--CUfsU";
var _4 = "PostHistory-module__sectionHeader--itq15";
var _5 = "PostHistory-module__sectionsContainer--kbXe6";
export { _1 as "animatedBackground", _2 as "restrictionContainer", _3 as "restrictionNote", _4 as "sectionHeader", _5 as "sectionsContainer" }
